import React from 'react';
import Navbar from '../components/Navbar';
import '../components/Navbar.css';
import CandidatesTable from '../components/CandidatesTable';

function CandidateNavPage() {
  document.title = 'Florida Elections - Candidates';

  
  return (
    <div style={{ background: '#ffffff', minHeight: '100vh', color: '#000' }}>
      <Navbar />

  <main style={{ maxWidth: '1000px', margin: '8px auto', padding: '12px' }}>
        <section style={{ padding: '10px 12px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
          <h2 style={{ marginTop: 0, paddingTop: 0 }}>Candidates</h2>
          <CandidatesTable />
        </section>
      </main>
    </div>
  );
}

export default CandidateNavPage;
